// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "project-slider/slider" + ".js?id=" + "48b8ce514c81b6e8" + "";
};